"use client";

import { useEffect, useRef, useState } from "react";

export default function BudgetIframe() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(1650);

  useEffect(() => {
    function handleMessage(e: MessageEvent) {
      if (e.data?.type === "budget-resize") {
        setHeight(e.data.height);
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  function handleLoad() {
    // Small delay to ensure iframe content is fully rendered
    setTimeout(() => {
      iframeRef.current?.contentWindow?.postMessage(
        { type: "budget-request-height" },
        "*",
      );
    }, 100);
  }

  return (
    <iframe
      ref={iframeRef}
      src="/budget/index_v5.html"
      width="100%"
      className="overflow-hidden"
      style={{ height: `${height}px` }}
      frameBorder="0"
      allowFullScreen
      onLoad={handleLoad}
    />
  );
}
